/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImplementIdDto } from './implementIdDto';
import { EmployeeIdDto } from './employeeIdDto';
import { GeoCoordinateDto } from './geoCoordinateDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface ExaBeaconStateV2Dto {
  employee?: EmployeeIdDto;
  id?: number;
  implement?: ImplementIdDto;
  lastSeen?: string;
  lastVoltage?: number;
  mac?: string;
  major?: number;
  minor?: number;
  owner?: EnterpriseIdDto;
  position?: GeoCoordinateDto;
  serial?: string;
  type?: string;
  updateTime?: string;
  uuid?: string;
}
